import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { useReleaseChangePolling } from "@/hooks/useReleaseChangePolling"
import { useVersionStore } from "@/stores/useVersionStore"

export const UpdateVersionBanner = () => {
  const { t } = useTranslation()
  useReleaseChangePolling()
  const isStaleVersion = useVersionStore((state) => state.isStaleVersion)

  if (!isStaleVersion) {
    return null
  }

  return (
    <Banner type="inline" variant="info" className="px-8">
      {t("common.updateVersionBanner.message")}
      <a onClick={() => window.location.reload()} className="cursor-pointer" role="button">
        {t("common.updateVersionBanner.refreshLink")}
      </a>
      {t("common.updateVersionBanner.warning")}
    </Banner>
  )
}
